import { init } from '@dash0/sdk-web';

// Dash0 RUM — only staging / prod builds (not local dev).

const isDash0Mode = () => {
  const mode = import.meta.env.MODE;
  return mode === 'staging' || mode === 'production';
};

const SERVICE_NAME_BASE = 'Booking Engine';

// Normalize env label for Dash0 (staging -> Staging, production -> Production).
const dash0EnvironmentLabel = (raw) => {
  const value = String(raw).trim();
  const lower = value.toLowerCase();
  if (lower === 'staging') return 'Staging';
  if (lower === 'production') return 'Production';
  return value;
};

// Requires VITE_DASH0_OTLP_URL + VITE_DASH0_AUTH_TOKEN. Optional: VITE_DASH0_SERVICE_NAME, VITE_DASH0_ENVIRONMENT.
export const initDash0 = () => {
  if (!isDash0Mode()) {
    return;
  }

  const url = import.meta.env.VITE_DASH0_OTLP_URL;
  const authToken = import.meta.env.VITE_DASH0_AUTH_TOKEN;
  if (!url || !authToken) {
    return;
  }

  const environment = dash0EnvironmentLabel(
    import.meta.env.VITE_DASH0_ENVIRONMENT?.trim() || import.meta.env.MODE,
  );
  const serviceName =
    import.meta.env.VITE_DASH0_SERVICE_NAME?.trim() ||
    `${SERVICE_NAME_BASE} ${environment}`;

  init({
    serviceName,
    environment,
    serviceNamespace: 'guestcentric',
    endpoint: {
      url: String(url).trim(),
      authToken: String(authToken).trim(),
    },
  });
};
